import { intl } from './intl';

export const { t: errorsT, Message: ErrorsMessage } = intl.createMessages({
    invalidFileType: {
        ru: 'Неправильный тип файлов. Поддерживаются только видеофайлы.',
        en: 'Invalid file type. Only video files are supported.',
    },
    filesSkippedFormat: {
        ru: '{count} файл(ов) пропущено из-за неподдерживаемого формата.',
        en: '{count} file(s) skipped due to unsupported format.',
    },
    filesSkippedFormatAlt: {
        ru: 'Файлов пропущено из-за неподдерживаемого формата: {count}',
        en: 'Files skipped due to unsupported format: {count}',
    },
    onlyOneFileAllowed: {
        ru: 'Можно загрузить только один файл',
        en: 'Only one file can be uploaded',
    },
    titleCannotBeEmpty: {
        ru: 'Название не может быть пустым',
        en: 'Title cannot be empty',
    },
    titleTooLong: {
        ru: 'Название должно содержать не более {maxLength} символов',
        en: 'Title must contain no more than {maxLength} characters',
    },
    allFilesMustHaveProfile: {
        ru: 'Для всех файлов должен быть выбран профиль и название не должно превышать лимит',
        en: 'All files must have a selected profile and title must not exceed the limit',
    },
    unknownError: {
        ru: 'Неизвестная ошибка',
        en: 'Unknown error',
    },
});
